import React from "react";

import { Grid } from "@material-ui/core";

type Props = {
  children: React.ReactNode;
};

export default function Right({ children }: Props) {
  return (
    <Grid justifyContent="flex-end" container spacing={2}>
      {React.Children.map(children, (child, key) => (
        <Grid item key={key}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
}
